import React from 'react';

import PropTypes from 'prop-types';

const LayoutPublicComponent = ({
    component: Component,
    layout: Layout,
    matchProps,
    rest,
}) => {
    return (
        <Layout isPublic {...rest}>
            <Component {...matchProps} />
        </Layout>
    );
};

LayoutPublicComponent.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    layout: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    matchProps: PropTypes.object,
    rest: PropTypes.object,
};

export default LayoutPublicComponent;
